import React, { useState, useEffect } from 'react';
import { navigate } from 'gatsby';
// import { isLoggedIn } from "../services/auth"

// checking if the user is logged in based on the expiration of their token

const ClientOnly = ({ children }) => {
    const [hasMounted, setHasMounted] = useState(false);

    useEffect(() => {
        setHasMounted(true);
    }, []);

    if (!hasMounted) {
        return null;
    }

    return children;
};

function isLoggedIn() {
    if (typeof window !== 'undefined' && localStorage.getItem('cid')) {
        let expiresAtDate = new Date(
            JSON.parse(localStorage.getItem('cid')).expiresAt
        ).valueOf();
        let today = new Date();
        today = today.valueOf();

        if (expiresAtDate > today) {
            return true;
        }
    } else {
        return false;
    }
}

const PrivateRouteChild = ({ component: Component, location, ...rest }) => {
    return (
        <>
            <Component {...rest} />
        </>
    );
};

const PrivateRoute = ({ component: Component, location, ...rest }) => {
    if (!isLoggedIn() && location.pathname !== `/accounts/login`) {
        navigate('/accounts/login');
        return null;
    }
    return (
        <ClientOnly>
            <Component {...rest} />
        </ClientOnly>
    );
};

export default PrivateRoute;
